import DivarAuthProvider from "../tools/contexts/DivarAuthContext";
import {Outlet} from "react-router-dom";

const AuthenticatedRouteLayout=()=>{
    return <DivarAuthProvider>
        <Outlet/>
    </DivarAuthProvider>
}
export default AuthenticatedRouteLayout;